import { render, staticRenderFns } from "./assigned-user.vue?vue&type=template&id=7a52d066&scoped=true"
import script from "./assigned-user.vue?vue&type=script&lang=js"
export * from "./assigned-user.vue?vue&type=script&lang=js"
import style0 from "./assigned-user.vue?vue&type=style&index=0&id=7a52d066&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a52d066",
  null
  
)

export default component.exports